import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import {
    mdiCheck,
    mdiDotsVertical,
    mdiTrendingDown,
    mdiTrendingNeutral,
    mdiTrendingUp,
} from '@mdi/js';

import { CmpsScoreCardScoreSectionComponent } from './scorecard-score-section.component';

@NgModule({
    declarations: [CmpsScoreCardScoreSectionComponent],
    imports: [
        CmpsIconModule,
        CommonModule,
        CmpsTooltipModule,
        CmpsButtonModule,
    ],
    exports: [CmpsScoreCardScoreSectionComponent],
})
export class CmpsScoreCardScoreSectionModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['trending-neutral', mdiTrendingNeutral],
            ['check', mdiCheck],
            ['dots', mdiDotsVertical],
            ['trending-up', mdiTrendingUp],
            ['trending-down', mdiTrendingDown],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
